<div class="card">
  <div class="card-header py-3 d-flex align-items-center justify-content-between">
    <h6 class="m-0 text-uppercase" i18n>Signer Notifications</h6>
    <button (click)="save()" class="btn btn-secondary-info">
      <i class="cs-icon cs-icon-save"></i>
      <ng-container i18n>Save</ng-container>
    </button>
  </div>
  <div class="card-body">
    <app-document-signer-notifications [form]="form.get('signer')"></app-document-signer-notifications>
  </div>
</div>

<div class="card mt-4">
  <div class="card-header py-3 d-flex align-items-center justify-content-between">
    <h6 class="m-0 text-uppercase" i18n>User Notifications</h6>
    <button (click)="save()" class="btn btn-secondary-info">
      <i class="cs-icon cs-icon-save"></i>
      <ng-container i18n>Save</ng-container>
    </button>
  </div>
  <div class="card-body">
    <app-document-user-notifications
      [form]="form.get('sender')"
      [receiverForm]="reminderForm"
    ></app-document-user-notifications>
  </div>
</div>
